import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import {
  FaBell,
  FaExclamationTriangle,
  FaFileInvoiceDollar,
  FaPaperPlane,
  FaDownload,
  FaFileExcel,
} from "react-icons/fa"
import { withTranslation } from "react-i18next"
import Configs from "../../../config"
import Swal from "sweetalert2"
import { fetchData } from "utils/Common_api_functions"

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false)
  const [notificationsData, setNotificationsData] = useState([])

  useEffect(() => {
    fetchSheetHistory()
  }, [])

  async function fetchSheetHistory() {
    const APIdata = await fetchData(() => {}, "logs/sheet")
    if (APIdata?.success) {
      setNotificationsData(APIdata?.data)
    }
  }

  const sendNotification = notification => {
    Swal.fire({
      icon: "success",
      title: "Notification Sent Successfully",
    })
  }

  const handleDownload = notification => {
    if (!notification?.sheetLink) {
      Swal.fire({
        icon: "error",
        title: "File Not Found",
        text: "No file available to download.",
      })
      return
    }

    const downloadUrl = `${Configs.imageUrl}${notification.sheetLink.replace(
      /\\/g,
      "/"
    )}`

    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = notification.fileName || "download"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const formatDate = dateStr => {
    if (!dateStr) return ""
    const date = new Date(dateStr)
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const getTypeLabel = type => {
    switch (type?.toLowerCase()) {
      case "kpi":
        return "KPI Sheet"
      case "missing":
        return "Missing Log"
      case "pending":
        return "Pending Task"
      default:
        return type || "File"
    }
  }

  const getTypeIcon = type => {
    switch (type?.toLowerCase()) {
      case "kpi":
        return <FaFileExcel className="text-success" />
      case "missing":
        return <FaExclamationTriangle className="text-warning" />
      case "pending":
        return <FaFileInvoiceDollar className="text-info" />
      default:
        return <FaBell className="text-secondary" />
    }
  }

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
      >
        <i className="bx bx-bell bx-tada text-white" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
        <div className="p-3">
          <Row className="align-items-center">
            <Col>
              <h6 className="m-0">{props.t("Sheet History")}</h6>
            </Col>
          </Row>
        </div>

        <SimpleBar style={{ height: "230px" }}>
          {notificationsData.length === 0 ? (
            <div className="text-center text-muted py-4">
              <FaBell size={24} className="mb-2 opacity-50" />
              <p className="mb-0 font-size-12">No notifications</p>
            </div>
          ) : (
            notificationsData.map(notification => (
              <div
                key={notification.id}
                className="text-reset notification-item d-flex align-items-start justify-content-between p-2 border-bottom"
                style={{ overflow: "hidden" }} // ← add this
              >
                {/* Left: Icon + Info */}
                {/* Left: Icon + Info — add minWidth: 0 */}
                <div
                  className="d-flex align-items-start flex-grow-1 me-2"
                  style={{ minWidth: 0 }}
                >
                  <div className="avatar-xs me-3 flex-shrink-0">
                    <span className="avatar-title bg-light rounded-circle fs-5">
                      {notification.icon ?? getTypeIcon(notification.type)}
                    </span>
                  </div>

                  {/* This inner div also needs minWidth: 0 for text-truncate to work */}
                  <div
                    className="overflow-hidden"
                    style={{ minWidth: 0, flex: 1 }}
                  >
                    <h6 className="mt-0 mb-1 text-truncate">
                      {notification.title ??
                        notification.fileName ??
                        "File Upload"}
                    </h6>
                    ...
                  </div>
                </div>

                {/* Right: Action Buttons */}
                <div className="d-flex flex-column gap-1 flex-shrink-0">
                  {/* Download button — shown when sheetLink exists */}
                  {notification.sheetLink && (
                    <button
                      className="btn btn-sm btn-success"
                      title={`Download ${notification.fileName || "file"}`}
                      onClick={() => handleDownload(notification)}
                    >
                      <FaDownload />
                    </button>
                  )}

                  {/* Send button — shown for missing/pending types */}
                  {(notification.type === "missing" ||
                    notification.type === "pending") && (
                    <button
                      className="btn btn-sm btn-primary"
                      title="Send Notification"
                      onClick={() => sendNotification(notification)}
                    >
                      <FaPaperPlane />
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </SimpleBar>
      </DropdownMenu>
    </Dropdown>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(NotificationDropdown)
